// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tripway Design System — shadcn-inspired tokens on Bootstrap */

:root {
  --ds-radius-sm: 6px;
  --ds-radius: 10px;
  --ds-radius-lg: 14px;
  --ds-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06);
  --ds-shadow-md: 0 4px 16px rgba(15, 23, 42, 0.08);
  --ds-shadow-hover: 0 8px 24px rgba(15, 23, 42, 0.1);
  --ds-border: #e2e8f0;
  --ds-muted: #64748b;
  --ds-ring: rgba(215, 100, 32, 0.35);
  --ds-accent: var(--green-color, #d76420);
  --ds-accent-soft: rgba(215, 100, 32, 0.1);
  --ds-card-bg: var(--basic-color, #fff);
  --ds-transition: 0.2s ease;
  --ds-space-1: 0.25rem;
  --ds-space-2: 0.5rem;
  --ds-space-3: 0.75rem;
  --ds-space-4: 1rem;
  --ds-space-5: 1.25rem;
  --ds-space-6: 1.5rem;
  --ds-space-8: 2rem;
  --ds-font-xs: 0.75rem;
  --ds-font-sm: 0.8125rem;
  --ds-font-md: 0.9375rem;
  --ds-font-lg: 1.125rem;
  --ds-font-xl: 1.5rem;
}

body.dark-theme {
  --ds-border: #334155;
  --ds-muted: #94a3b8;
  --ds-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.25);
  --ds-shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);
  --ds-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.4);
  --ds-accent-soft: rgba(215, 100, 32, 0.18);
  --ds-card-bg: var(--basic-color, #1e293b);
}

.ds-card {
  background: var(--ds-card-bg);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow);
  transition: box-shadow var(--ds-transition), border-color var(--ds-transition),
    transform var(--ds-transition);
}

.ds-card--interactive:hover {
  box-shadow: var(--ds-shadow-hover);
  border-color: color-mix(in srgb, var(--ds-accent) 35%, var(--ds-border));
  transform: translateY(-2px);
}

.ds-skeleton {
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--ds-border) 70%, transparent) 0%,
    color-mix(in srgb, var(--ds-border) 40%, transparent) 50%,
    color-mix(in srgb, var(--ds-border) 70%, transparent) 100%
  );
  background-size: 200% 100%;
  animation: ds-shimmer 1.4s ease-in-out infinite;
  border-radius: var(--ds-radius-sm);
}

@keyframes ds-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes ds-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ds-fade-in {
  animation: ds-fade-in 0.35s ease both;
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,+EAA+E;EAC/E,iDAAiD;EACjD,mDAAmD;EACnD,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wEAAwE;EACxE,8CAA8C;EAC9C,gDAAgD;EAChD,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B;kCACgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,wEAAwE;EACxE,2BAA2B;AAC7B;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* Tripway Design System — shadcn-inspired tokens on Bootstrap */\n\n:root {\n  --ds-radius-sm: 6px;\n  --ds-radius: 10px;\n  --ds-radius-lg: 14px;\n  --ds-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06);\n  --ds-shadow-md: 0 4px 16px rgba(15, 23, 42, 0.08);\n  --ds-shadow-hover: 0 8px 24px rgba(15, 23, 42, 0.1);\n  --ds-border: #e2e8f0;\n  --ds-muted: #64748b;\n  --ds-ring: rgba(215, 100, 32, 0.35);\n  --ds-accent: var(--green-color, #d76420);\n  --ds-accent-soft: rgba(215, 100, 32, 0.1);\n  --ds-card-bg: var(--basic-color, #fff);\n  --ds-transition: 0.2s ease;\n  --ds-space-1: 0.25rem;\n  --ds-space-2: 0.5rem;\n  --ds-space-3: 0.75rem;\n  --ds-space-4: 1rem;\n  --ds-space-5: 1.25rem;\n  --ds-space-6: 1.5rem;\n  --ds-space-8: 2rem;\n  --ds-font-xs: 0.75rem;\n  --ds-font-sm: 0.8125rem;\n  --ds-font-md: 0.9375rem;\n  --ds-font-lg: 1.125rem;\n  --ds-font-xl: 1.5rem;\n}\n\nbody.dark-theme {\n  --ds-border: #334155;\n  --ds-muted: #94a3b8;\n  --ds-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.25);\n  --ds-shadow-md: 0 4px 16px rgba(0, 0, 0, 0.35);\n  --ds-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.4);\n  --ds-accent-soft: rgba(215, 100, 32, 0.18);\n  --ds-card-bg: var(--basic-color, #1e293b);\n}\n\n.ds-card {\n  background: var(--ds-card-bg);\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow);\n  transition: box-shadow var(--ds-transition), border-color var(--ds-transition),\n    transform var(--ds-transition);\n}\n\n.ds-card--interactive:hover {\n  box-shadow: var(--ds-shadow-hover);\n  border-color: color-mix(in srgb, var(--ds-accent) 35%, var(--ds-border));\n  transform: translateY(-2px);\n}\n\n.ds-skeleton {\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--ds-border) 70%, transparent) 0%,\n    color-mix(in srgb, var(--ds-border) 40%, transparent) 50%,\n    color-mix(in srgb, var(--ds-border) 70%, transparent) 100%\n  );\n  background-size: 200% 100%;\n  animation: ds-shimmer 1.4s ease-in-out infinite;\n  border-radius: var(--ds-radius-sm);\n}\n\n@keyframes ds-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes ds-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ds-fade-in {\n  animation: ds-fade-in 0.35s ease both;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
